exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".admin-container[data-v-0b458ece]{padding:20px;min-height:100vh}.card[data-v-0b458ece]{border:none;border-radius:8px}.card-header[data-v-0b458ece]{background-color:#f8f9fa;border-bottom:2px solid #dee2e6;padding:1rem 1.5rem}.table[data-v-0b458ece]{font-size:.95rem}.table thead th[data-v-0b458ece]{border-bottom:2px solid #dee2e6;font-weight:600;color:#495057}.table tbody tr[data-v-0b458ece]{transition:background-color .2s}.table tbody tr[data-v-0b458ece]:hover{background-color:#f8f9fa}.btn-sm[data-v-0b458ece]{padding:.25rem .75rem;font-size:.875rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0b458ece","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Admin.vue
// module id = 79
// module chunks = 0